<template>
  <div class="nps-main" v-show="isShow && showNps">
    <div  class="logo-box">
      <img src="https://files.wondercv.com/PC/editor/service/nps.png"/>
      <div class="logo-text-box">满意度小调查</div>
    </div>
    <div class="nps-header">
      <p class="title">你愿意推荐好友使用超级简历吗？</p>
      <i class="iconfont iconclose" @click="handleCloseNps"></i>
    </div>
    <div class="flex-tag">
      <p><i class="iconfont iconbumanyi"></i>非常不愿意</p>
      <p><i class="iconfont iconmanyi"></i>非常愿意</p>
    </div>
    <div class="score-box">
      <div class="num-item" v-for="(item, index) in 11" :key="index" :class="{active: index === chooseIndex}" @click="handleChooseGrade(index)">
        {{index}}
      </div>
    </div>
    <div v-if="chooseIndex != -1" class="text-box">
      <p>{{chooseIndex <= 6 ? '是我们没做好，请吐槽，让我们做得更好' : (chooseIndex > 6 &&chooseIndex <= 8 ? '感谢认可！您认为我们需要哪些改进' : '感谢认可！您希望有什么新功能吗？')}}</p>
      <textarea id="textarea" placeholder="请输入" v-model="suggestion"></textarea>
      <div class="sub-btn" @click="handleSubmit">
        提交
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import Cookies from "js-cookie";
import { get_tUser } from '@/assets/js/util';
import { getUserIdentity } from "@/api/list/nps";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    token: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showNps:false,
      arr: [
        {
          key: 0,
          active: false
        },
        {
          key: 1,
          active: false
        },
        {
          key: 2,
          active: false
        },
        {
          key: 3,
          active: false
        },
        {
          key: 4,
          active: false
        },
        {
          key: 5,
          active: false
        },
        {
          key: 6,
          active: false
        },
        {
          key: 7,
          active: false
        },
        {
          key: 8,
          active: false
        },
        {
          key: 9,
          active: false
        },
        {
          key: 10,
          active: false
        }
      ],
      chooseIndex: -1,
      suggestion: "",
      user_id: "",
      identity: "",
      env: "",
      _c_t: ""
    };
  },
  created(){
    this._c_t = get_tUser().c_t || ''
    this.getIdentity()
    this.env = process.env.HOST_ROOT
    this.showNps = this.isShow;
  },
  methods: {
    handleChooseGrade(index) {
      this.chooseIndex = index;
      console.log(index);
      this.arr.map(item => {
        item.active = false;
      });
      this.arr.splice(index, 1, { key: index, active: true });
      this.is_fill = 1;
      // this.submit();
    },
    handleCloseNps() {
      this.showNps = false;
      // this.$emit("showNps");
      // this.is_fill = 0;
      this.is_fill = this.chooseIndex === -1 ? 0 : 1;
      this.submit();
    },
    // 提交建议
    handleSubmit() {
      // user_id
      this.is_fill = 1;
      this.submit();
      this.showNps = false;
      // )
    },
    submit() {
      let _t = Cookies.get("_t");
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split(".")[1]));
        this.user_id = tokenPayload.User.c_t;
      }
      // console.log(
      api.nps
        .addNps({
          score: this.chooseIndex == -1 ? 0 : this.chooseIndex,
          channel: 6,
          comment: this.suggestion,
          label: 0,
          resume_token: this.token,
          user_id: this.user_id,
          is_fill: this.is_fill
        })
        .then(res => {
          if (res.code == 1000) {
            if (this.is_fill) {
              this.$message.success("提交成功，感谢您的评价！");
            }
          }
        })
        .catch(err => {})
    },
    async getIdentity () {
      try {
        let res = await getUserIdentity(this._c_t)
        if(res.code === 1000) {
          this.identity = res.data.g_identity
        } else {
          console.log(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
  .nps-main{
    position: fixed;
    width: 375px;
    background: #FFFFFF;
    box-shadow: 0px 2px 16px 0px rgba(1, 23, 92, 0.14);
    border-radius: 12px;
    right: 110px;
    bottom: 72px;
    padding: 24px;
    z-index: 1;
    .logo-box{
      position: absolute;
      display: flex;
      top: -55px;
      left: 11px;
      img{
        width: 59px;
        height: 55px;
      }
      .logo-text-box{
        width: 96px;
        height: 24px;
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        border-radius: 12px;
        margin-left: 4px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 24px;
      }
    }
    .nps-header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 28px;
      .title{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #404040;
        line-height: 22px;
      }
      .iconfont{
        font-size: 12px;
        position: absolute;
        right: 0;
        top: -26px;
        cursor: pointer;
        color: #cfcfcf;
        &:hover{
          color: #fff;
        }
      }
    }
    .flex-tag{
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #9C9C9C;
      line-height: 17px;
      margin-bottom: 10px;
      p{
        display: flex;
        align-items: center;
        i {
          margin-right: 4px;
          font-size: 12px;
        }
      }
    }
    .score-box{
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      .num-item{
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid rgba(255, 102, 68, 0.3);
        color: #FF6644;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        &.active{
          background: #FF6644;
          color: #FFF;
        }
      }
    }
    .text-box{
      margin-top: 12px;
      margin-bottom: -8px;
      & > p{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #404040;
        line-height: 20px;
        margin-bottom: 8px;
      }
      #textarea{
        width: 100%;
        height: 120px;
        background: #F9F9F9;
        border-radius: 6px;
        border: 1px solid #ECECEC;
        resize: none;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 16px;
        font-size: 14px;
        color: #404040;
        &:focus{
          outline:#ececec;
        }
      }
      .sub-btn{
        height: 44px;
        background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        border-radius: 22px;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
        color: #fff;
      }
    }
  }
.cv-nps {
  width: 100%;
  height: 210px;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: -800px;
  z-index: 1000000001;
  box-shadow:0px -4px 10px 0px rgba(226,226,226,1);
  .main {
    display: flex;
    justify-content: center;
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .section {
      width: 736px;
      padding-top: 48px;
      margin: 0 24px;
      position: relative;
      .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1;
        color: #404040FF;
        margin-bottom: 20px;
      }
      .invite {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        &>* {
          white-space: nowrap;
        }
        .title {
          margin: 0;
        }
        .copy-link-detail {
          font-size: 14px;
          color: #606060FF;
          margin: 0 16px;
        }
        .copy-btn {
          font-size: 14px;
          color: #4183FFFF;
          cursor: pointer;
        }
      }
      .grade-list {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9c9c9c;
        margin-top: 24px;
        .grade {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 24px;
          .grade-item {
            width: 32px;
            height: 32px;
            border: 1px solid #9C9C9CFF;
            border-radius: 50%;
            font-size: 14px;
            color: #9C9C9CFF;
            text-align: center;
            line-height: 32px;
            // margin: 0 24px;
            cursor: pointer;
          }
          .grade-item.active {
            border: 1px solid #ff4f4c;
            background: #ff4f4c;
            color: #fff;
          }
        }
      }
      .suggestion {
        display: flex;
        align-items: flex-end;
        .suggestion-text {
          padding: 10px;
          display: block;
          width: 600px;
          height: 40px;
          border: 1px solid #CFCFCFFF;
          resize: none;
          font-size: 14px;
          color: #606060;
          outline: none;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .send-suggestion {
          width: 120px;
          height: 40px;
          font-size: 16px;
          color: #fff;
          text-align: center;
          line-height: 40px;
          padding: 0;
          margin-left: 16px;
          border-radius: 4px;
          background: #ff4f4c;
          cursor: pointer;
        }
      }
      &.good-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 0;
        height:210px;
      }
    }
    .sign-btn {
      position: absolute;
      top: 18px;
      padding: 10px;
      cursor: pointer;
      & > i {
        font-size: 20px;
        font-weight: bold;
        color: #8C8C8CFF;
      }
    }
    .close-btn {
      right: 100px;
    }
    .back-btn {
      left: 100px;
    }
  }
}

.cv-nps.active {
  bottom: 0;
  transition: all 1.5s;
}
// .cv-nps.close {
//   bottom: -100px;
//   animation: close 1s;
//   -moz-animation: close 1s; /* Firefox */
//   -webkit-animation: close 1s; /* Safari 和 Chrome */
//   -o-animation: close 1s; /* Opera */
// }
</style>
